module.exports = __webpack_public_path__ + "media/ivy-post2.9ec3c380.mp4";